// extracted by mini-css-extract-plugin
export default {"languages_container":"SelectLanguage_languages_container__B1Asc","selected_language":"SelectLanguage_selected_language__-oFVo","languages":"SelectLanguage_languages__wTK5y"};